import { createContext, useContext, type PropsWithChildren } from "react";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "./api";
import type { User } from "../types";

type SessionValue = { user: User | null; loading: boolean; refresh: () => Promise<unknown>; logout: () => Promise<void> };
const SessionContext = createContext<SessionValue | null>(null);

export function SessionProvider({ children }: PropsWithChildren) {
  const client = useQueryClient();
  const query = useQuery({ queryKey: ["session"], queryFn: () => api<{ user: User | null }>("/api/auth/me"), staleTime: 60_000 });
  const logout = async () => {
    await api("/api/auth/logout", { method: "POST" });
    client.setQueryData(["session"], { user: null });
  };
  return <SessionContext.Provider value={{ user: query.data?.user || null, loading: query.isLoading, refresh: () => query.refetch(), logout }}>{children}</SessionContext.Provider>;
}

export function useSession() {
  const value = useContext(SessionContext);
  if (!value) throw new Error("SessionProvider is missing");
  return value;
}
